import { Heading } from '@ctct/payflow-ui';
import { Spinner } from '@ctct/presentation-layer';

import './payment-processing-info-widget.scss';
import type { PaymentProcessingInfoWidgetProps } from './usePaymentProcessingInfoWidget';

export const PaymentProcessingInfoWidget = ({ data, hooks }: PaymentProcessingInfoWidgetProps) => {
  const isVisible = hooks.useIsVisible();
  const { title, text } = data.getContent();

  if (!isVisible) {
    return null;
  }

  return (
    <div className="payment-processing-info-widget">
      <Heading level="h5">{title}</Heading>
      <p>{text}</p>
      <div className="spinner-container">
        <Spinner size="xl" />
      </div>
    </div>
  );
};
